
import MediaHelper from '../helpers/MediaHelper';

/**
 * Calculate top offset to get ideal scroll position.
 * Helper Function.
 *
 * @param      {string|Element}  selector  The selector
 * @return     {number}  The element offset top.
 */
const getElementOffsetTop = ( selector ) => {

	// Get Element via selector or directly.
	const element = selector instanceof Element ? selector : document.querySelector( selector );
	if ( ! element ) {
		return 0;
	}

	// Get distance from the element to the top of the page.
	const elementOffsetTop = element.getBoundingClientRect().top + window.scrollY;
	const serviceRowHeight = document.querySelector( '.mdl_servicerow' ).offsetHeight;

	if ( MediaHelper.matches( 'desktop' ) ) {

		// Static 105 for Headerbar.
		const headerBarHeight = 105;
		return elementOffsetTop - ( headerBarHeight + serviceRowHeight + 2 );
	}

	// On Listpages there is an additional element we need to take into account for mobile scrolling.
	const listPageControlsEl = document.querySelector( '.en_mdl_listcontrols' );
	if ( listPageControlsEl ) {
		return elementOffsetTop - listPageControlsEl.offsetHeight;
	}

	return elementOffsetTop;
};

const initScrollToTopListeners = () => {

	document.addEventListener( 'click', ( ev ) => {
		// Scroll Back to Top.
		if ( ev.target && ev.target.closest( '.js_back_to_top' ) ) {
			ev.preventDefault();
			window.scrollTo( { top: 0, behavior: 'smooth' } );
		}

		// Scroll to Top of Filters.
		if ( ev.target && ev.target.closest( '.js_filter_back_to_top' ) ) {
			ev.preventDefault();

			const offsetTop = getElementOffsetTop( '.mdl_filter' );
			window.scrollTo( { top: offsetTop, behavior: 'smooth' } );
		}

		// Scroll Down to SEO Text.
		if ( ev.target && ev.target.closest( '.js_listpageheader-button' ) ) {
			ev.preventDefault();

			const offsetTop = getElementOffsetTop( '#seotext_cms' );
			window.scrollTo( { top: offsetTop, behavior: 'smooth' } );
		}
	} );
}

export {
	getElementOffsetTop,
	initScrollToTopListeners
}
